import { render } from "./CampaignsLatest5Performance.vue?vue&type=template&id=15c6d89e&scoped=true"
import script from "./CampaignsLatest5Performance.vue?vue&type=script&lang=js"
export * from "./CampaignsLatest5Performance.vue?vue&type=script&lang=js"

import "./CampaignsLatest5Performance.vue?vue&type=style&index=0&id=15c6d89e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c6d89e"]])

export default __exports__